export const messages = {
    "shared-link.footer.link.install": "Попробуйте {brandName} бесплатно",
    "shared-link.footer.link.mobile": "{brandName} для мобильных устройств",
    "shared-link.footer.link.android": "Android",
    "shared-link.footer.link.ios": "iOS",
    "shared-link.password-dialog-box.title": "Защищенные данные",
    "shared-link.password-dialog-box.message": "Укажите пароль для доступа к общим данным",
    "shared-link.password-dialog-box.hint.password": "Пароль",
    "shared-link.password-dialog-box.message.invalid-password": "Неправильный пароль",
    "shared-link.form.button.open": "Открыть",
    "shared-link.page-not-found.title": "Страница не найдена",
    "shared-link.page-not-found.message.main": "Страница, которую вы искали, не найдена.",
    "shared-link.page-not-found.message.description": "Возможно, ссылка устарела или вы ввели неправильный адрес.",
    "shared-link.page-not-found.message.error": "Код ошибки: 404",
    "shared-link.restore-file.label.size": "Размер",
    "shared-link.restore-file.button.restore": "Загрузить",
    "shared-link.links-table.column.name": "Имя",
    "shared-link.links-table.column.size": "Размер",
    "shared-link.links-table.action.restore": "Загрузить",
    "shared-link.links-table.action.restore-all": "Загрузить все",
    "shared-link.side-bar.selected.title:plural": "{count} элемента выбрано | {count} элемент выбран | {count} элемента выбрано | {count} элементов выбрано | {count} элемента выбрано",
    "shared-link.links-table.label.size": "Размер",
    "shared-link.links-table.message.empty-folder": "Эта папка пуста"
};
